import {
  Button,
  Flex,
  TextField,
  Card,
  PhoneNumberField,
} from "@aws-amplify/ui-react";
import { Controller } from "react-hook-form";

export default function EmergencyContactFormItem({
  control,
  emergencyContact,
  index,
  onEmergencyContactDelete,
  remove,
  errors,
  getValues,
  setValue
}) {
  console.log(emergencyContact)
  return (
    <>
      <Card padding={0}>
        <Flex direction="column" alignItems="flex-start">
          <Controller
            name={`emergencyContacts.${index}.id`}
            control={control}
            defaultValue={emergencyContact?.id}
            render={({ field }) => <input type="hidden" {...field} />}
          />
          <Controller
            name={`emergencyContacts.${index}.name`}
            control={control}
            defaultValue={emergencyContact?.name}
            render={({ field }) => (
              <TextField
                minWidth="300px"
                label="*Full Name"
                {...field}
                errorMessage={
                  errors.emergencyContacts
                    ? errors.emergencyContacts[index]?.name?.message
                    : null
                }
                hasError={
                  !!(errors?.emergencyContacts?.length > 0
                    ? errors?.emergencyContacts[index]?.name
                    : null)
                }
              />
            )}
          />
          <Controller
            name={`emergencyContacts.${index}.relationship`}
            control={control}
            defaultValue={emergencyContact?.relationship}
            render={({ field }) => (
              <TextField
                minWidth="300px"
                label="*Emergency contact relationship"
                {...field}
                errorMessage={
                  errors.emergencyContacts
                    ? errors.emergencyContacts[index]?.relationship?.message
                    : null
                }
                hasError={
                  !!(errors?.emergencyContacts?.length > 0
                    ? errors?.emergencyContacts[index]?.relationship
                    : null)
                }
              />
            )}
          />
          <Controller
            name={`emergencyContacts.${index}.phone`}
            control={control}
            defaultValue={emergencyContact?.phone}
            render={({ field }) => (
              <PhoneNumberField
                {...field}
                label="Phone"
                defaultDialCode={emergencyContact.dialCode ?? "+1"}
                dialCodeName={`emergencyContacts.${index}.dialCode`}
                dialCodeLabel="Dial Code"
                errorMessage={
                  errors.emergencyContacts
                    ? errors.emergencyContacts[index]?.phone?.message
                    : null
                }
                hasError={
                  !!(errors?.emergencyContacts?.length > 0
                    ? errors?.emergencyContacts[index]?.phone
                    : null)
                }
                onChange={(e) => {
                  const dialCode = getValues(
                    `emergencyContacts[${index}].dialCode`
                  );
                  if (!dialCode) {
                    setValue(`emergencyContacts[${index}].dialCode`, "+1");
                  }
                  field.onChange(e.target.value);
                }}
                onDialCodeChange={(e) => {
                  setValue(
                    `emergencyContacts[${index}].dialCode`,
                    e.target.value
                  );
                }}
              />
            )}
          />
          <Button
            variation="destructive"
            onClick={() => {
              if (emergencyContact?.id) {
                onEmergencyContactDelete(emergencyContact?.id);
              }
              remove(index);
            }}
          >
            Delete Contact
          </Button>
        </Flex>
      </Card>
    </>
  );
}
